import { render, staticRenderFns } from "./InvoiceDataTableDetails.template.vue?vue&type=template&id=73873120&scoped=true&"
var script = {}
import style0 from "./InvoiceDataTableDetails.template.vue?vue&type=style&index=0&id=73873120&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73873120",
  null
  
)

export default component.exports